var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("Copyright 2007-"+_vm._s(_vm.currentYear)+"©LaoYaoBa.com™Inc.All rights reserved | 闽ICP备17032949号-2")]),_vm._v(" "),_c('p',[_vm._v("闽公网安备 35020502000344号")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2ca7776","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Footer.vue
// module id = null
// module chunks = 